import { TSupplierFeature } from '@/api';

/**
 * Gets all features from a feature tree as a flat array with enabled: true
 * This is useful for showing all features as selected when supplier.features is undefined
 */
export const getAllFeaturesAsEnabled = (features: TSupplierFeature[]): TSupplierFeature[] => {
  const result: TSupplierFeature[] = [];
  
  const traverse = (featureList: TSupplierFeature[]) => {
    featureList.forEach(feature => {
      result.push({
        key: feature.key,
        name: feature.name,
        enabled: true,
        children: feature.children,
      });
      
      if (feature.children) {
        traverse(feature.children);
      }
    });
  };
  
  traverse(features);
  return result;
};
